function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M31.0565 0C14.4497 0 0.984375 13.4421 0.984375 30.0203C0.984375 46.5985 14.4497 60.0406 31.0565 60.0406C47.6633 60.0406 61.1286 46.5985 61.1286 30.0203C61.1342 13.4421 47.6689 0 31.0565 0ZM10.1055 17.6442H10.1673C10.6562 19.9051 14.0675 21.6555 18.1982 21.6555C22.3344 21.6555 25.7401 19.9051 26.229 17.6442H26.2908C26.2459 21.2347 22.6435 24.1408 18.1982 24.1408C13.7528 24.1408 10.1504 21.2403 10.1055 17.6442ZM31.0565 47.2493C23.7619 47.2493 17.8385 42.8509 17.771 37.409H17.8722C18.6758 40.8312 24.2733 43.4849 31.0565 43.4849C37.8453 43.4849 43.4371 40.8312 44.2408 37.409H44.3419C44.2745 42.8509 38.3567 47.2493 31.0565 47.2493ZM43.9148 24.1408C39.4695 24.1408 35.8615 21.2403 35.8222 17.6442H35.884C36.3729 19.9051 39.7842 21.6555 43.9148 21.6555C48.0511 21.6555 51.4567 19.9051 51.9457 17.6442H52.0075C51.9682 21.2403 48.3602 24.1408 43.9148 24.1408Z",
  fill: "white"
});

var SvgEmoji4 = function SvgEmoji4(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 61,
    viewBox: "0 0 62 61",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmoji4, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/emoji_4.f395de95.svg";
export { ForwardRef as ReactComponent };